<span class="badge d-inline-flex align-items-center cursor-pointer" *ngIf="value" (click)="copy($event)">
  <i class="bi bi-copy me-2"></i> {{ label }} : {{ value }}
</span>
